export function hexToRgb(hex: string): { r: number; g: number; b: number } {
	const r: number = parseInt(hex.slice(1, 3), 16);
	const g: number = parseInt(hex.slice(3, 5), 16);
	const b: number = parseInt(hex.slice(5, 7), 16);
	return { r, g, b };
}

export function rgbToHex(r: number, g: number, b: number): string {
	return `#${[r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('')}`;
}

export function lightenColor(hex: string, percent: number): string {
	const { r, g, b } = hexToRgb(hex);
	const amount: number = Math.round(0.55 * percent);
	return rgbToHex(Math.min(255, r + amount), Math.min(255, g + amount), Math.min(255, b + amount));
}

export function transformData(dataArray: any[] | null): any {
	if (!dataArray || !Array.isArray(dataArray)) {
		return { name: 'root', children: [] };
	}
	return {
		name: 'root',
		children: dataArray.map((data) => transformNode(data, 1, null)).filter(Boolean),
	};
}

export function transformNode(node: any, level: number, sessionCountParent: number | null): any {
	if (!node || level > 5) return null;
	const totalSumNextSteps = node.nextSteps ? node.nextSteps.reduce((sum: number, nextStep: any) => sum + nextStep.sessionCount, 0) : 0;
	const abandonedSessionCount = node.sessionCount - totalSumNextSteps;
	const abandonedRate = (node.sessionCount - totalSumNextSteps) / node.sessionCount * 100;
	const sessionCountProportionByParent = level !== 1 && node.sessionCount && sessionCountParent ? (node.sessionCount / sessionCountParent) * 100 : 0;
	return {
		name: node.id,
		value: node.sessionCount || 0,
		turnover: node.turnover || 0,
		sessionCount: node.sessionCount || 0,
		sessionCountProportionByParent: sessionCountProportionByParent,
		convertedSessionCount: node.convertedSessionCount || 0,
		children: node.nextSteps ? node.nextSteps.map((childNode: any) => transformNode(childNode, level + 1, node.sessionCount)).filter(Boolean) : [],
		abandonedSessionCount: abandonedSessionCount,
		abandonedRate: abandonedRate,
		level: level,
		topUrls: node.topUrls ? node.topUrls : [],
		trafficSources: node.trafficSources ? node.trafficSources : [],
		VisEngLevels: node.VisEngLevels ? node.VisEngLevels : [],
	};
}

export const colors: string[] = [
	'#000',
	'#5355e8',
	'#48cd8a',
	'#ffcc3e',
	'#e93c69',
	
	'#b066dd',
	'#54b4f9',
	'#93D57C',
	'#d254c3',
	'#fc7b2d',
];
const pageTypesLabels = [
	{
		value : 'H',
		label : 'Home'
	},
	{
		value : 'C',
		label : 'Category page'
	},
	{
		value : 'FP',
		label : 'Product page'
	},
	{
		value : 'B',
		label : 'Basket'
	},
	{
		value : 'T',
		label : 'Transaction'
	},
	{
		value : 'G',
		label : 'Generic'
	},
	{
		value : 'O',
		label : 'Other'
	},
	{
		value: 'LostSession',
		label: 'Site exit'
	}

];
export const visitorEngagementLevels: { value: string, label: string }[] = [
	{ value: 'X', label: 'Lost' },
	{ value: 'C', label: 'Consideration' },
	{ value: 'D', label: 'Discover' },
	{ value: 'I', label: 'Intention' },
	{ value: 'A', label: 'Purchase' },
	{ value: 'E', label: 'Experience' },
	{ value: 'R', label: 'Recurring purchase' },
	{ value: 'none', label: 'None' }
];
export function findVisitorEngagementLevel(id: string):string {
	const foundLabel = visitorEngagementLevels.find(level => level.value === id);
	return  foundLabel ? foundLabel.label : id.length > 0 ? id : 'Empty' ;
}
export function getPageTypeLabel(lid:string) {
	const foundLabel = pageTypesLabels.find(item => item.value === lid);
	return foundLabel ? foundLabel.label : lid.length > 0 ? lid : 'Empty';
}


